var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"rounded":"","size":"is-small","icon-left":'map-search',"type":'is-warning is-light',"label":_vm.toggleMapLabel(_vm.type)},on:{"click":function($event){return _vm.toggleMapView(_vm.type)}}})}
var staticRenderFns = []

export { render, staticRenderFns }